import {Container, Flex, Text} from '@chakra-ui/react';
import {useFormDate} from 'hooks';
import {FC} from 'react';
import {IRatingItem} from 'types';

import {ShowRating} from '../showRating';

interface IProps {
  review: IRatingItem;
}

export const ReviewItem: FC<IProps> = ({review}) => {
  const {date} = useFormDate(review.modified, 'dd.MM.yyyy');

  return (
    <>
      {review.comment && (
        <Container variant="white-block" mb={['10px', '20px']}>
          <Flex alignItems="center" justifyContent="space-between">
            <Flex w="75%" flexDirection="column">
              <Text>{review.customer_name}</Text>
              <ShowRating grade={review.rating} />
              {!!review.comment.length && (
                <Text variant="Text.baseStyle" fontWeight={500} mt={['10px', '14p']} fontSize={['14px', '16px']}>
                  {review.comment}
                </Text>
              )}
            </Flex>
            <Text variant="Text.baseStyle" fontSize={['14px', '16px']} fontWeight={500}>
              {date}
            </Text>
          </Flex>
        </Container>
      )}
    </>
  );
};
